module.exports = {
          srcSet: __webpack_public_path__ + "6c4893e3cb5ebad51512854613d60756-23.png"+" 23w",
          images:[ {path: __webpack_public_path__ + "6c4893e3cb5ebad51512854613d60756-23.png",width: 23,height: 22}],
          src: __webpack_public_path__ + "6c4893e3cb5ebad51512854613d60756-23.png",
          toString:function(){return __webpack_public_path__ + "6c4893e3cb5ebad51512854613d60756-23.png"},
          
          width: 23,
          height: 22
        }